/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcSuccessCircleRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path d="M17.078 9.86a.9.9 0 0 0-1.268-1.276l-5.52 5.481-2.1-2.086a.9.9 0 0 0-1.269 1.277l2.735 2.716a.9.9 0 0 0 1.268 0z" />
      <path
        fillRule="evenodd"
        d="M12 1.1C5.98 1.1 1.1 5.98 1.1 12S5.98 22.9 12 22.9 22.9 18.02 22.9 12 18.02 1.1 12 1.1M2.9 12a9.1 9.1 0 1 1 18.2 0 9.1 9.1 0 0 1-18.2 0"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcSuccessCircleRegular;
